export default "__VITE_ASSET__CKlb5N0n__"